module.exports = __webpack_public_path__ + "img/s1.fcbc22a8.png";